import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import { DisplayResult } from 'src/app/models/DisplayResult';
import {CseRoundResult, ElectionResults, ReceivedPoll} from 'src/app/models/ReceivedPoll';
import { Common } from 'src/app/shared/common';
import {AssessorData} from '../../models/AssessorData';

@Component({
    selector: 'app-cse-results',
    templateUrl: 'cse-results.component.html',
    styleUrls: ['./cse-results.component.less', '../../shared/common.less']
})

export class CseResultsComponent implements OnInit {
    @Input() pollData: ReceivedPoll;
    @Input() results: DisplayResult[];
    @Input() cseRoundResult: ElectionResults;
    @Input() votes: number = 0;
    @Input() categoryTitle: string;
    @Input() value: string;
    @Input() note: string;
    @Input() blockchainLink: string;
    @Input() activeElectionToDisplay: number;
    isExpanded: boolean = true;

    constructor(
        public common: Common
    ) { }

    toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {}
}
